(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sc-lead-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.scReady) return;
      root.dataset.scReady = 'true';
      const params = new URLSearchParams(window.location.search);
      const form = root.querySelector('form');
      const path = window.location.pathname;
      const language = ['en','de','es','it','da','no','fr','ar','pt'].includes(path.split('/')[1]) ? path.split('/')[1] : (document.documentElement.lang || 'sv');
      root.querySelector('[data-sc-language]').value = language;
      root.querySelector('[data-sc-landing]').value = path.slice(0,300);
      const interests = {cold:'Isbad',sauna:'Bastu',both:'Både isbad och bastu',custom:'Skräddarsytt projekt'};
      const requested = interests[params.get('interest')];
      if (requested && !form.querySelector('input[type="radio"]:checked')) {
        Array.from(form.querySelectorAll('input[type="radio"]')).find(input => input.value === requested)?.click();
      }
      root.querySelectorAll('a[href^="#sc-contact-"]').forEach(link => {
        link.addEventListener('click', () => {
          const title = root.querySelector('.sc-leads__contact h2');
          title.setAttribute('tabindex','-1');
          title.focus({preventScroll:true});
        });
      });
      const success = root.querySelector('[data-sc-lead-success]');
      success?.focus();
      const conversionKey = 'sc-lead-pending-' + form.id;
      const marketingAllowed = () => {
        const privacy = window.Shopify?.customerPrivacy;
        return privacy?.marketingAllowed() === true && privacy?.analyticsProcessingAllowed() === true;
      };
      form.addEventListener('submit', () => {
        if (!form.checkValidity() || !marketingAllowed()) return;
        try {
          sessionStorage.setItem(conversionKey, JSON.stringify({
            id: crypto.randomUUID(), created: Date.now(), sent: false
          }));
        } catch {}
      });
      if (success) {
        let attempts = 0;
        const recordLead = () => {
          if (!marketingAllowed()) return;
          let pending;
          try { pending = JSON.parse(sessionStorage.getItem(conversionKey)); } catch { return; }
          if (!pending?.id || pending.sent || Date.now() - pending.created > 3600000) return;
          if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
            if (++attempts < 20) setTimeout(recordLead, 500);
            return;
          }
          window.dataLayer = window.dataLayer || [];
          window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
          try {
            sessionStorage.setItem(conversionKey, JSON.stringify({ ...pending, sent: true }));
            window.gtag('event', 'conversion', {
              send_to: 'AW-16607418294/r0t2CMnrgKscELavhO89',
              transaction_id: pending.id,
              value: 1,
              currency: 'SEK'
            });
            success.dataset.scConversionStatus = 'queued';
          } catch {}
        };
        recordLead();
        document.addEventListener('visitorConsentCollected', recordLead);
      }
      root.querySelectorAll('[data-sc-campaign]').forEach((input) => { input.value = (params.get(input.dataset.scCampaign) || '').slice(0,300); });
    };
    document.querySelectorAll('[data-sc-leads]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-sc-leads]').forEach(init));
  })();

  } catch(e) { console.error(e); }
})();
})();
